const Loader = {
    script : function(url, objName, cb){
        var script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", url);
        document.getElementsByTagName("head")[0].appendChild(script);

        let timeout = 100; // 5 seconds timeout
        let isLoaded = function () {
            setTimeout(function () {
                timeout--;
                if (typeof window[objName] !== 'undefined'){
                    cb();
                }
                else if (timeout > 0) {
                    isLoaded();
                }
                else {
                    console.error(url + ", failed to load.");
                }
            }, 100);
        };
        isLoaded();
    }
};

module.exports = Loader;


// WEBPACK FOOTER //
// ./src/control/util/Loader.js